<template>
  <span>
  <div id='gallery' :class="{'active': active}" v-if="trip">
    <a herf="#" @click.prevent="closeGallery()"><img class="close-btn" src="../assets/times.png"></a>
    <div class="slider" @mouseenter="paused = true" @mouseleave="paused = false" v-if="active">
      <div class="slideNav" v-if="hasImages">
        <a href="#" @click.prevent="prevImg()" class="prevNav"><i class="fa fa-angle-left" aria-hidden="true"></i></a>
        <a href="#" @click.prevent="nextImg()" class="nextNav"><i class="fa fa-angle-right" aria-hidden="true"></i></a>
      </div>
<!--         Removed because directive didn't exist, might need to add npm module
        v-touch:swipeLeft="onSwipeLeft"
        v-touch:swipeRight="onSwipeRight" -->
      <div 
        v-for="(image, index) in currentDest.gallery" 
        class="slide" 
        v-if="active" 
        :class="{'activeImage': activeImage === index}">
        <span class="helper"></span>
        <img class="responsive-img" :src="image.url">
        <div class="slideCap">
          <h5>{{image.title}}</h5>
          <p>{{image.caption}}</p>
        </div>
      </div>
    </div>
  </div>
  </span>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      images: [this],
      activeImage: 0,
      paused: false,
      interval: null
    }
  },

  watch: {
    'active': function (value) {
      this.activeImage = 0
      if (this.currentDest.gallery.length > 0 && value) {
        clearInterval(this.interval)
        this.interval = setInterval(function () {
          if (this.paused) { return }
          if (this.activeImage === this.currentDest.gallery.length - 1) {
            this.activeImage = 0
          } else {
            this.activeImage = this.activeImage + 1
          }
        }.bind(this), 5000)
      }
    },
    'rightActive': function () {
      if (this.rightActive === false) {
        this.closeGallery()
      }
    }
  },

  computed: {
    ...mapState({
      active: state => state.galleryActive,
      rightActive: state => state.rightPanelActive,
      trip: state => state.currentTrip,
      currentDest: state => state.currentDest
    }),
    hasImages () {
      return this.currentDest.gallery.length > 1
    }
  },

  methods: {
    ...mapActions({
      closeGallery: 'closeGallery'
    }),
    nextImg: function (value) {
      var gallery = this.currentDest.gallery
      var galLength = this.currentDest.gallery.length - 1
      var index = this.activeImage
      this.paused = true
      if (index >= 0 && index < galLength) {
        this.activeImage = this.activeImage + 1
      }
      if (index === galLength) {
        this.activeImage = 0
      }
    },

    prevImg: function (value) {
      var gallery = this.currentDest.gallery
      var galLength = this.currentDest.gallery.length - 1
      var index = this.activeImage
      this.paused = true
      if (index > 0 && index <= galLength) {
        this.activeImage = this.activeImage - 1
      }
      if (index === 0) {
        this.activeImage = galLength
      }
    },

    onSwipeLeft: function (value) {
      var gallery = this.currentDest.gallery
      var galLength = this.currentDest.gallery.length - 1
      var index = this.activeImage
      this.paused = true
      if (index >= 0 && index < galLength) {
        this.activeImage = this.activeImage + 1
      }
      if (index === galLength) {
        this.activeImage = 0
      }
    },

    onSwipeRight: function (value) {
      var gallery = this.currentDest.gallery
      var galLength = this.currentDest.gallery.length - 1
      var index = this.activeImage
      this.paused = true
      if (index > 0 && index <= galLength) {
        this.activeImage = this.activeImage - 1
      }
      if (index === 0) {
        this.activeImage = galLength
      }
    }
  }
}
</script>
<style scoped>
  #gallery {
    bottom: 0;
    left: -65%;
    top: 0;
    height: 100%;
    width: 65%;
    position: absolute;
    z-index: 9999;
    background-color: rgba(4,57,105,1);
    transition: all .5s ease;
  }
  #gallery.active {
    left: 0;
  }
  .close-btn {
    float: left;
    margin: 20px;
    z-index: 9999;
    position: relative;
    cursor: pointer;
  }
  .slideNav a {
    position:absolute;
    z-index:99;
    top:calc(50% - 80px);
    color:#fff;
    opacity:0.7;
    font-size:3.5em;
    transition:all 0.5s ease;
  }
  .slideNav a:hover, .slideNav a:active {
    opacity:1;
  }
  .slideNav a.prevNav {
    padding-left:20px;
    left:-50px;
  }
  .slider:hover a.prevNav {
    left:0;
  }
  .slideNav a.nextNav {
    right:-50px;
    padding-right:20px;
  }
  .slider:hover a.nextNav {
    right:0;
  }
  .slider {
    position:relative;
    height: calc(100% - 114px);
    clear:both;
  }
  .slide {
    position:absolute;
    height:100%;
    width: 100%;
    top:0;
    left:0;
    white-space:nowrap;
    text-align:center;
    opacity:0;
    visibility: hidden;
  }
  .slide img {
    opacity:0;
    visibility:hidden;
    transition:opacity 0.75s ease;
  }
  .slide.activeImage, .slide.activeImage img {
    opacity:1;
    visibility: visible;
  }
  .helper {
    display:inline-block;
    height:calc(100% - 112px);
    vertical-align:middle;
  }
  .slide img.responsive-img {
    max-width:100%;
    width: auto;
    max-height:calc(100% - 112px);
    height:auto;
    vertical-align:middle;
  }
  .slideCap {
    position:absolute;
    bottom:0;
    width:100%;
    height:112px;
    background:#fff;
    text-align:left;
    white-space:normal;
    padding:.5em 1em;
    box-sizing:border-box;
    font-size:.875em;
    overflow-y:scroll;
  }

  @media (max-width : 769px) {
    .slideCap p {
      display: none;
    }
  }

  @media (max-width : 769px) and (orientation: portrait) {
    #gallery {
      bottom: 0;
      left: -100%;
      top: 0;
      height: calc(55% - 60px);
      width: 100%;
      position: absolute;
      z-index: 9999;
      background-color: rgba(4,57,105,0.75);
      transition: all .5s ease;
    }
    #gallery.active {
      left: 0;
    }
    .slider {
      position:relative;
      height: calc(100% - 54px);
      clear:both;
    }
    .slide img.responsive-img {
      max-height:calc(100% - 30px);
      left:-5px;
      position: relative;
    }
    .helper {
      height: calc(100% - 30px);
    }
    .slideCap {
      height:30px;
      padding:0 1em;
    }
    .slideCap h5 {
      margin:.75em 0;
    }
    .slideNav a {
      top: calc(50% - 54px);
    }
  }

  @media (max-width : 769px) and (orientation: landscape) {
    .slider {
      position:relative;
      height: calc(100% - 89px);
      clear:both;
    }
    .slide img.responsive-img {
      max-height:calc(100% - 30px);
      position:relative;
      left:-5px;
    }
    .helper {
      height: calc(100% - 30px);
    }
    .slideCap {
      height:30px;
      padding:0 1em;
    }
    .slideCap h5 {
      margin:.75em 0;
    }
    .slideNav a {
      top: calc(50% - 58px);
    }
  }
</style>



// WEBPACK FOOTER //
// Gallery.vue?7e67c097